import React from 'react';
import { useCachedImage } from '../hooks/useCachedImage';
import { getTransformedImageUrl, type ImageSize } from '../utils/imageTransform';

interface CachedImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string | undefined;
  size?: ImageSize;
}

export function CachedImage({ src, alt, size = 'medium', ...props }: CachedImageProps) {
  // Apply transformation before caching
  const transformedSrc = size ? getTransformedImageUrl(src, size) : src;
  const cachedSrc = useCachedImage(transformedSrc);

  if (!cachedSrc) {
    return null;
  }

  return <img src={cachedSrc} alt={alt} {...props} />;
}
